var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{attrs:{"items":_vm.countries,"item-value":"code","item-text":"name","label":"Country","no-data-text":"No country found","dense":"","outlined":"","clearable":""},on:{"change":_vm.onChangeHandler},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})
}
var staticRenderFns = []

export { render, staticRenderFns }